module.exports = __webpack_public_path__ + "img/arm.be5030ca.webp";